// extracted by mini-css-extract-plugin
export var animationContainer = "_pc-0";
export var footer = "_pc-1";
export var gray = "_pc-2";
export var lineItem = "_pc-3";
export var lineItemImage = "_pc-4";
export var lineItemInfo = "_pc-5";
export var lineItemText = "_pc-6";
export var lineItems = "_pc-7";
export var modalContent = "_pc-8";
export var options = "_pc-9";
export var orderName = "_pc-a";
export var refundAmount = "_pc-b";